import { render, staticRenderFns } from "./DynamicPageFooter.vue?vue&type=template&id=b65365c2&scoped=true&"
import script from "./DynamicPageFooter.vue?vue&type=script&lang=js&"
export * from "./DynamicPageFooter.vue?vue&type=script&lang=js&"
import style0 from "./DynamicPageFooter.vue?vue&type=style&index=0&id=b65365c2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b65365c2",
  null
  
)

export default component.exports